import { EventTypeLevel } from './EventTypeLevel';
import { ConditionalMandatory } from './ConditionalMandatory';
import { EventTypeDataVersion } from './EventTypeDataVersion';
import { EventTypeFilter } from './EventTypeFilter';
import { AlternateEventTypeGroupMap } from './AlternateEventTypeGroupMap';

export class EventTypeData {
    constructor(
        eventTypeLevelArray: EventTypeLevel[],
        conditionalMandatoryArray: ConditionalMandatory[],
        eventTypeDataVersion: EventTypeDataVersion | null,
        eventTypeFilterList: EventTypeFilter[],
        alternateEventTypeGroupMapList: AlternateEventTypeGroupMap[],
        hasOrcaWebSimpleMode?: boolean | null
    ) {
        this.eventTypeLevelArray = eventTypeLevelArray;
        this.conditionalMandatoryArray = conditionalMandatoryArray;
        this.eventTypeDataVersion = eventTypeDataVersion;
        this.eventTypeFilterList = eventTypeFilterList;
        this.alternateEventTypeGroupMapList = alternateEventTypeGroupMapList;
        this.hasOrcaWebSimpleMode = hasOrcaWebSimpleMode;
    }
    eventTypeLevelArray: EventTypeLevel[];
    conditionalMandatoryArray: ConditionalMandatory[];
    eventTypeDataVersion: EventTypeDataVersion | null;
    eventTypeFilterList: EventTypeFilter[];
    alternateEventTypeGroupMapList: AlternateEventTypeGroupMap[];
    hasOrcaWebSimpleMode?: boolean | null;

    public getVersion(): string | null {
        if (this.eventTypeDataVersion) {
            return this.eventTypeDataVersion.version;
        }
        return null;
    }
}
